/* ============================================================
   vw.js — Vintage Watcholic shell.
   Drawers, Ajax cart (Section Rendering API), quick view,
   variant pickers, predictive search, wishlist, recently viewed,
   hero slider, rails, reveal-on-scroll and the PDP gallery.
   Wishlist + recently viewed persist to localStorage (per browser).
   ============================================================ */
(function () {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const CART_SECTION = 'vw-cart-drawer';
  const parse = html => new DOMParser().parseFromString(html, 'text/html');

  const store = {
    read(k, f) { try { const v = JSON.parse(localStorage.getItem('vw_' + k)); return v == null ? f : v; } catch (e) { return f; } },
    write(k, v) { try { localStorage.setItem('vw_' + k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- overlays ------------------------------------ */
  let openEl = null, lastFocus = null;
  function open(id) {
    const el = document.getElementById(id);
    if (!el) return false;
    if (openEl && openEl !== el) openEl.classList.remove('is-open');
    el.classList.add('is-open');
    document.body.classList.add('is-locked');
    if (!openEl) lastFocus = document.activeElement;
    openEl = el;
    if (id === 'vsearch') setTimeout(() => { const i = $('#searchInput'); if (i) i.focus(); }, 90);
    else setTimeout(() => { const b = el.querySelector('.vdrawer__close, .qv__close'); if (b) b.focus({ preventScroll: true }); }, 60);
    if (id === 'wish') renderWish();
    return true;
  }
  function close() {
    if (!openEl) return;
    openEl.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    openEl = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- toast --------------------------------------- */
  let toastT;
  function toast(msg) {
    const t = $('#toast'); if (!t) return;
    $('#toastT').textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(() => t.classList.remove('is-on'), 2600);
  }

  /* ---------- cart ---------------------------------------- */
  function setCartCount(n) {
    n = Number(n) || 0;
    $$('[data-count="cart"]').forEach(e => { e.textContent = n; e.dataset.empty = n ? 'false' : 'true'; });
  }
  function applyCart(sections) {
    if (!sections || !sections[CART_SECTION]) return;
    const fresh = parse(sections[CART_SECTION]).querySelector('#cart');
    const cur = $('#cart');
    if (!fresh || !cur) return;
    const openCx = $$('[data-cx]', cur).map(c => c.classList.contains('is-open'));
    const body = $('.vdrawer__body', cur), top = body ? body.scrollTop : 0;
    cur.innerHTML = fresh.innerHTML;
    const nb = $('.vdrawer__body', cur); if (nb) nb.scrollTop = top;
    $$('[data-cx]', cur).forEach((c, i) => { if (openCx[i]) c.classList.add('is-open'); });
    setCartCount(fresh.dataset.cartCount);
    syncWish();
  }
  async function cartPost(path, body) {
    body.sections = CART_SECTION;
    body.sections_url = location.pathname;
    const res = await fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Something went wrong — please try again.');
    return data;
  }
  async function addToCart(items, btn, then) {
    if (btn) btn.classList.add('is-loading');
    try {
      const data = await cartPost('cart/add.js', { items });
      applyCart(data.sections);
      if (then === 'checkout') { location.href = ROOT + 'checkout'; return; }
      if (openEl && openEl.id === 'qv') close();
      open('cart');
    } catch (err) {
      toast(err.message);
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  }
  let lineBusy = false;
  async function changeLine(key, quantity, btn) {
    if (lineBusy) return;
    lineBusy = true;
    if (btn) btn.classList.add('is-loading');
    try {
      const data = await cartPost('cart/change.js', { id: key, quantity });
      applyCart(data.sections);
      if (quantity === 0) toast('Removed from bag');
    } catch (err) { toast(err.message); }
    finally { lineBusy = false; if (btn && btn.isConnected) btn.classList.remove('is-loading'); }
  }
  let noteT;
  function saveCartField(body) {
    clearTimeout(noteT);
    noteT = setTimeout(() => {
      fetch(ROOT + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).catch(() => {});
    }, 500);
  }
  async function applyDiscount(form) {
    const code = form.discount.value.trim(); if (!code) return;
    try {
      const data = await cartPost('cart/update.js', { discount: code });
      const hit = (data.discount_codes || []).find(d => d.code.toLowerCase() === code.toLowerCase());
      applyCart(data.sections);
      if (hit && !hit.applicable) {
        const msg = $('#cart [data-discount-msg]');
        if (msg) { msg.textContent = '“' + code + '” can’t be applied to this bag.'; msg.hidden = false; }
        const cx = msg && msg.closest('[data-cx]'); if (cx) cx.classList.add('is-open');
      }
    } catch (err) { toast(err.message); }
  }

  /* ---------- variant pickers ------------------------------ */
  function initPickers(scope) {
    $$('[data-vpicker]', scope).forEach(p => {
      if (p._vw) return; p._vw = true;
      let variants = [];
      try { variants = JSON.parse(p.querySelector('[data-variants]').textContent); } catch (e) { return; }
      p.addEventListener('click', e => {
        const b = e.target.closest('.opt__b'); if (!b) return;
        $$('.opt__b', b.parentElement).forEach(x => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
        const chosen = [];
        $$('.opt__row', p).forEach((row, i) => { const on = row.querySelector('.is-on'); chosen[i] = on ? on.dataset.optV : null; });
        const v = variants.find(x => x.options.every((o, i) => o === chosen[i]));
        updateVariant(p.closest('[data-qv-root], [data-pdp]') || document, v, p.dataset.vpicker);
      });
    });
  }
  function updateVariant(root, v, scope) {
    const price = v ? v.price : '';
    $$('[data-price]', root).forEach(e => { e.textContent = price; });
    $$('[data-compare]', root).forEach(e => { e.textContent = v && v.compare ? v.compare : ''; });
    const save = $('[data-save]', root); if (save && (!v || !v.compare)) save.hidden = true;
    const input = $('[data-variant-input]', root); if (input && v) input.value = v.id;
    const ok = !!(v && v.available);
    const addText = $('[data-add-text]', root);
    if (addText) addText.textContent = ok ? 'Add To Bag · ' + price : (v ? 'Sold Out' : 'Unavailable');
    $$('[data-add-btn], [data-sticky-add], [data-buynow]', root).forEach(b => b.setAttribute('aria-disabled', ok ? 'false' : 'true'));
    if (scope === 'qv') {
      const b = $('[data-add]', root);
      if (b && v) { b.dataset.add = v.id; b.textContent = ok ? 'Add To Bag · ' + price : 'Sold Out'; b.setAttribute('aria-disabled', ok ? 'false' : 'true'); }
    }
    // switch to the variant's own photo
    if (v && v.media) {
      if (scope === 'pdp') document.dispatchEvent(new CustomEvent('vw:variant-media', { detail: { id: v.media } }));
      if (scope === 'qv' && v.img) { const qi = $('.qv__media img', root); if (qi) { qi.removeAttribute('srcset'); qi.src = v.img; } }
    }
    if (scope === 'pdp' && v) {
      const sel = $('[data-sticky-variant]'); if (sel) sel.value = v.id;
      const u = new URL(location.href); u.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', u.toString());
    }
  }

  /* ---------- quick view ---------------------------------- */
  async function openQV(url, btn) {
    if (btn) btn.classList.add('is-loading');
    try {
      const res = await fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=vw-quick-view');
      const root = parse(await res.text()).querySelector('[data-qv-root]');
      if (!root) throw new Error();
      const panel = $('#qvPanel');
      panel.innerHTML = '';
      panel.appendChild(document.importNode(root, true));
      initPickers(panel);
      syncWish();
      open('qv');
    } catch (e) {
      location.href = url;
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  }

  /* ---------- wishlist ------------------------------------ */
  let wish = store.read('wish', []);
  const cardCache = {};
  async function fetchCard(handle) {
    if (cardCache[handle]) return cardCache[handle];
    const res = await fetch(ROOT + 'products/' + encodeURIComponent(handle) + '?view=vw-card');
    if (!res.ok) throw new Error('gone');
    const doc = parse(await res.text());
    cardCache[handle] = doc;
    return doc;
  }
  function syncWish() {
    const n = wish.length;
    $$('[data-count="wish"]').forEach(e => { e.textContent = n; e.dataset.empty = n ? 'false' : 'true'; });
    $$('[data-wishn]').forEach(e => { e.textContent = n; });
    $$('[data-wish]').forEach(b => {
      if (b.classList.contains('cline__rm')) return;
      const on = wish.includes(b.dataset.wish);
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function toggleWish(handle) {
    const i = wish.indexOf(handle);
    if (i > -1) { wish.splice(i, 1); toast('Removed from wishlist'); }
    else { wish.unshift(handle); toast('Saved to wishlist'); }
    store.write('wish', wish);
    syncWish();
    if (openEl && openEl.id === 'wish') renderWish();
  }
  async function renderWish() {
    const list = $('[data-wish-list]'), empty = $('[data-wish-empty]');
    if (!list) return;
    empty.hidden = wish.length > 0;
    list.hidden = !wish.length;
    const lines = await Promise.all(wish.map(h => fetchCard(h).then(doc => {
      const t = doc.querySelector('template[data-line]');
      return t ? t.innerHTML : '';
    }).catch(() => { wish = wish.filter(x => x !== h); return ''; })));
    store.write('wish', wish);
    list.innerHTML = lines.join('');
    empty.hidden = wish.length > 0;
    syncWish();
  }

  /* ---------- predictive search --------------------------- */
  function initSearch() {
    const input = $('#searchInput'), box = $('#searchResults'), label = $('#searchLabel'), all = $('#searchAll');
    if (!input || !box) return;
    const trending = box.innerHTML, trendingHref = all ? all.href : '';
    let t, ctrl;
    const panel = $('#vsearch');
    async function run(q) {
      q = q.trim();
      if (panel) panel.classList.toggle('has-q', !!q);
      if (!q) { box.innerHTML = trending; label.textContent = 'Trending Now'; if (all) all.href = trendingHref; syncWish(); return; }
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      try {
        const res = await fetch(ROOT + 'search/suggest?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&section_id=vw-predictive-search', { signal: ctrl.signal });
        const wrap = parse(await res.text()).querySelector('[data-results-count]');
        if (!wrap) return;
        const n = Number(wrap.dataset.resultsCount) || 0;
        box.innerHTML = wrap.innerHTML;
        label.textContent = n ? n + (n > 1 ? ' matches' : ' match') : 'No matches';
        if (all) all.href = ROOT + 'search?type=product&q=' + encodeURIComponent(q);
        syncWish();
      } catch (e) {}
    }
    input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => run(input.value), 180); });
    document.addEventListener('click', e => {
      const sq = e.target.closest('[data-q]');
      if (sq && sq.closest('#vsearch')) { input.value = sq.dataset.q; run(sq.dataset.q); input.focus(); }
    });
  }

  /* ---------- hero slider --------------------------------- */
  function initHero(hero) {
    const slides = $$('.hero__slide', hero), dots = $$('.hero__dot', hero), num = $('[data-hero-num]', hero);
    if (slides.length < 2) return;
    const ms = Number(hero.dataset.autoplay) || 6000;
    dots.forEach(d => { const i = d.querySelector('i'); if (i) i.style.transitionDuration = ms + 'ms'; });
    let cur = 0, timer;
    const pad = n => String(n).padStart(2, '0');
    function go(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('is-on', n === cur));
      dots.forEach(d => { d.classList.remove('is-on'); const f = d.querySelector('i'); f.style.transition = 'none'; f.style.width = '0'; });
      void dots[cur].offsetWidth;
      const f = dots[cur].querySelector('i'); f.style.transition = ''; f.style.width = '';
      f.style.transitionDuration = ms + 'ms';
      dots[cur].classList.add('is-on');
      if (num) num.textContent = pad(cur + 1) + ' / ' + pad(slides.length);
      restart();
    }
    function restart() { clearInterval(timer); timer = setInterval(() => go(cur + 1), ms); }
    hero.addEventListener('click', e => {
      const a = e.target.closest('[data-hero]'); if (a) return go(cur + Number(a.dataset.hero));
      const d = e.target.closest('[data-godot]'); if (d) return go(Number(d.dataset.godot));
    });
    // swipe on touch screens (arrows are hidden on phones)
    let sx = null;
    hero.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', e => {
      if (sx == null) return;
      const dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 45) go(cur + (dx < 0 ? 1 : -1));
    });
    hero.addEventListener('mouseenter', () => clearInterval(timer));
    hero.addEventListener('mouseleave', restart);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) go(0);
  }

  /* ---------- rails --------------------------------------- */
  function initRail(nav) {
    const track = $('[data-rail]', nav.closest('section')); if (!track) return;
    const step = () => track.clientWidth * 0.62;
    nav.addEventListener('click', e => {
      const b = e.target.closest('[data-dir]'); if (!b) return;
      track.scrollBy({ left: Number(b.dataset.dir) * step(), behavior: 'smooth' });
    });
    const upd = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      nav.querySelector('[data-dir="-1"]').disabled = track.scrollLeft <= 2;
      nav.querySelector('[data-dir="1"]').disabled = track.scrollLeft >= max;
    };
    track.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  /* ---------- reveal on scroll ---------------------------- */
  let io;
  function reveal(scope) {
    const els = $$('.reveal:not(.is-in)', scope);
    if (!('IntersectionObserver' in window)) { els.forEach(el => el.classList.add('is-in')); return; }
    io = io || new IntersectionObserver(es => es.forEach(en => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(el => io.observe(el));
  }

  /* ---------- PDP ----------------------------------------- */
  function initPDP(pdp) {
    const stage = $('[data-stage]', pdp), img = stage && $('.gal__img', stage);
    if (stage && img) {
      // One controller: thumbnails, ‹ › arrows, keyboard and the lightbox all call show(i)
      const thumbs = $$('.gal__thumb', pdp);
      const idxLabel = $('[data-gal-index]', pdp);
      let cur = Math.max(0, thumbs.findIndex(t => t.classList.contains('is-on')));
      thumbs.forEach(t => new Image().src = t.dataset.thumb); // warm the cache so switching is instant
      function show(i) {
        if (!thumbs.length) return;
        cur = (i + thumbs.length) % thumbs.length;
        const t = thumbs[cur];
        thumbs.forEach(x => x.classList.toggle('is-on', x === t));
        if (idxLabel) idxLabel.textContent = (cur + 1) + ' / ' + thumbs.length;
        img.style.opacity = 0;
        setTimeout(() => { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = t.dataset.thumb; img.style.opacity = 1; }, 140);
        const list = t.parentElement;
        if (list && getComputedStyle(list).flexDirection === 'column') list.scrollTo({ top: t.offsetTop - list.clientHeight / 2 + t.offsetHeight / 2, behavior: 'smooth' });
        else if (list) list.scrollTo({ left: t.offsetLeft - list.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
      }
      thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
      document.addEventListener('vw:variant-media', e => {
        const i = thumbs.findIndex(t => t.dataset.mediaId === String(e.detail.id));
        if (i > -1 && i !== cur) show(i);
      });
      $$('[data-gal]', stage).forEach(b => b.addEventListener('click', e => { e.stopPropagation(); show(cur + Number(b.dataset.gal)); }));
      document.addEventListener('keydown', e => {
        if (openEl || /input|textarea|select/i.test(document.activeElement.tagName)) return;
        if (e.key === 'ArrowLeft') show(cur - 1);
        if (e.key === 'ArrowRight') show(cur + 1);
      });
      $$('[data-lb-i]', pdp).forEach(b => b.addEventListener('click', () => { close(); show(Number(b.dataset.lbI)); }));
      // swipe on touch
      let sx = null;
      stage.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', e => { if (sx == null) return; const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); sx = null; });
      if (window.matchMedia('(hover: hover)').matches) {
        stage.addEventListener('mousemove', e => {
          const onArrow = !!e.target.closest('.gal__arrow');
          stage.classList.toggle('is-zoom', !onArrow);
          if (onArrow) return;
          const r = stage.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
        stage.addEventListener('mouseleave', () => { stage.classList.remove('is-zoom'); img.style.transformOrigin = 'center'; });
      }
    }

    const rail = $('[data-thumbrail]', pdp);
    if (rail) {
      const list = $('.gal__thumbs', rail), up = $('[data-thumbs="-1"]', rail), down = $('[data-thumbs="1"]', rail);
      const vertical = () => getComputedStyle(list).flexDirection === 'column';
      const step = () => { const t = list.querySelector('.gal__thumb'); return t ? (t.offsetHeight + 10) * 2 : 160; };
      const upd = () => {
        const over = list.scrollHeight > list.clientHeight + 2;
        rail.classList.toggle('has-more', vertical() && over);
        up.disabled = list.scrollTop <= 2;
        down.disabled = list.scrollTop + list.clientHeight >= list.scrollHeight - 2;
      };
      up.addEventListener('click', () => list.scrollBy({ top: -step(), behavior: 'smooth' }));
      down.addEventListener('click', () => list.scrollBy({ top: step(), behavior: 'smooth' }));
      list.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }

    const form = $('[data-product-form]', pdp);
    const err = $('[data-form-error]', pdp);
    const items = () => {
      const list = [{ id: Number(form.querySelector('[data-variant-input]').value), quantity: 1 }];
      $$('[data-addon-group] .opt__b.is-on', form).forEach(b => { if (b.dataset.addon) list.push({ id: Number(b.dataset.addon), quantity: 1 }); });
      return list;
    };
    if (form) {
      form.addEventListener('submit', e => {
        e.preventDefault();
        const btn = $('[data-add-btn]', form);
        if (btn.getAttribute('aria-disabled') === 'true') return;
        if (err) err.hidden = true;
        addToCart(items(), btn);
      });
      form.addEventListener('click', e => {
        const a = e.target.closest('[data-addon-group] .opt__b');
        if (a) $$('.opt__b', a.parentElement).forEach(x => x.classList.toggle('is-on', x === a));
        const bn = e.target.closest('[data-buynow]');
        // Breeze checkout attaches to .shopify-payment-button; if it has taken the click, stay out of its way
        if (bn && !e.defaultPrevented && bn.getAttribute('aria-disabled') !== 'true') addToCart(items(), bn, 'checkout');
      });
    }

    const bar = $('[data-stickybuy]', pdp), box = $('.buybox', pdp);
    if (bar && box && 'IntersectionObserver' in window) {
      document.body.classList.add('has-stickybuy');
      new IntersectionObserver(es => bar.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0), { threshold: 0 }).observe(box);
      const sa = $('[data-sticky-add]', bar);
      // the sticky button shows its own spinner and adds directly
      if (sa) sa.addEventListener('click', () => { if (sa.getAttribute('aria-disabled') !== 'true' && form) addToCart(items(), sa); });
      // variant dropdown in the sticky bar drives the main option buttons (which update price, button and URL)
      const sel = $('[data-sticky-variant]', bar), picker = $('[data-vpicker="pdp"]', pdp);
      if (sel && picker) sel.addEventListener('change', () => {
        let variants = [];
        try { variants = JSON.parse(picker.querySelector('[data-variants]').textContent); } catch (e) { return; }
        const v = variants.find(x => String(x.id) === sel.value); if (!v) return;
        $$('.opt__row', picker).forEach((row, i) => {
          const b = $$('.opt__b', row).find(x => x.dataset.optV === v.options[i]);
          if (b && !b.classList.contains('is-on')) b.click();
        });
      });
    }

    const dv = $('[data-deliv]', pdp);
    if (dv) deliveryEstimate(dv);

    const rv = store.read('rv', []).filter(h => h !== pdp.dataset.handle);
    rv.unshift(pdp.dataset.handle);
    store.write('rv', rv.slice(0, 12));
  }

  function deliveryEstimate(el) {
    // Work in IST regardless of the visitor's clock.
    const now = new Date(Date.now() + (new Date().getTimezoneOffset() + 330) * 60000);
    const cutoff = Number(el.dataset.cutoff) || 17;
    const ship = new Date(now);
    let today = now.getDay() !== 0 && now.getHours() < cutoff;
    if (!today) { ship.setDate(ship.getDate() + 1); ship.setHours(10, 0, 0, 0); }
    while (ship.getDay() === 0) ship.setDate(ship.getDate() + 1);
    const add = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); if (x.getDay() === 0) x.setDate(x.getDate() + 1); return x; };
    const fmt = d => d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    const fmtShort = d => d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric' });
    const local = add(ship, Number(el.dataset.local) || 1);
    const a = add(ship, Number(el.dataset.min) || 3), b = add(ship, Number(el.dataset.max) || 6);
    let lead;
    if (today) {
      const mins = cutoff * 60 - (now.getHours() * 60 + now.getMinutes());
      lead = 'Order in the next <b>' + Math.floor(mins / 60) + ' hrs ' + (mins % 60) + ' min</b> and it ships today.';
    } else {
      lead = 'Ships <b>' + fmt(ship) + '</b>.';
    }
    const t = el.querySelector('[data-deliv-t]');
    if (t) t.innerHTML = lead + ' ' + (el.dataset.localLabel || 'Local') + ' <b>' + fmt(local) + '</b> · rest of India <b>' + fmtShort(a) + ' – ' + fmt(b) + '</b>.';
  }

  /* ---------- recently viewed / recommendations ----------- */
  async function initRecent(sec) {
    const limit = Number(sec.dataset.limit) || 4;
    const list = store.read('rv', []).filter(h => h !== sec.dataset.current).slice(0, limit);
    if (!list.length) return;
    const cards = await Promise.all(list.map(h => fetchCard(h).then(doc => {
      const c = doc.querySelector('.pcard'); return c ? c.outerHTML : '';
    }).catch(() => '')));
    const html = cards.join('');
    if (!html) return;
    $('[data-recent-grid]', sec).innerHTML = html;
    sec.hidden = false;
    syncWish();
  }
  async function initRecs(sec) {
    try {
      const res = await fetch(sec.dataset.url);
      const fresh = parse(await res.text()).querySelector('[data-recs-grid]');
      if (!fresh || !fresh.querySelector('.pcard')) return;
      $('[data-recs-grid]', sec).innerHTML = fresh.innerHTML;
      sec.hidden = false;
      syncWish();
    } catch (e) {}
  }

  /* ---------- announcement / header ----------------------- */
  function initAnnounce(rot) {
    const items = $$('.announce__item', rot);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, Number(rot.dataset.speed) || 4200);
  }

  /* ---------- nav: long columns fold after 8 links -------- */
  function foldNavColumns() {
    $$('#nvd .nvd__col').forEach(col => {
      const links = $$(':scope > a', col);
      if (links.length <= 8 || col.querySelector('.nvd__more')) return;
      const extra = links.slice(8);
      extra.forEach(a => { a.hidden = true; });
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'nvd__more'; b.setAttribute('aria-expanded', 'false');
      const label = open => open ? 'Show less' : '+ ' + extra.length + ' more';
      b.textContent = label(false);
      b.addEventListener('click', () => {
        const opening = b.getAttribute('aria-expanded') === 'false';
        extra.forEach(a => { a.hidden = !opening; });
        b.setAttribute('aria-expanded', opening); b.textContent = label(opening);
      });
      col.appendChild(b);
    });
  }

  /* ---------- journal: table of contents ------------------- */
  function initTOC(toc) {
    const body = $('[data-article-body]'); if (!body) return;
    const heads = $$('h1, h2', body).filter(h => h.textContent.trim().length > 2);
    if (heads.length < 3) return;   // short posts don't need a contents list
    const list = $('[data-toc-list]', toc);
    const slug = t => t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
    const used = {};
    heads.forEach(h => {
      let id = h.id || slug(h.textContent) || 'section';
      while (used[id]) id += '-2';
      used[id] = 1; h.id = id;
      const li = document.createElement('li');
      li.innerHTML = '<a href="#' + id + '"></a>';
      li.firstChild.textContent = h.textContent.trim();
      list.appendChild(li);
    });
    toc.hidden = false;
    const links = $$('a', list);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => es.forEach(en => {
        if (!en.isIntersecting) return;
        links.forEach(a => a.classList.toggle('is-on', a.getAttribute('href') === '#' + en.target.id));
      }), { rootMargin: '-15% 0px -70% 0px' });
      heads.forEach(h => io.observe(h));
    }
  }

  /* ---------- Instafeed app: clickable @handles ----------
     The Instafeed app renders its story strip into #insta-feed after
     load. Each "@username" label becomes a link to that Instagram
     profile with a small Instagram icon (clicking it doesn't open the
     app's popup). */
  function enhanceInstafeed() {
    const box = document.getElementById('insta-feed'); if (!box) return;
    const icon = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>';
    const fix = () => $$('.instafeed-story__label:not([data-vw-ig])', box).forEach(l => {
      const m = l.textContent.trim().match(/^@([A-Za-z0-9._]+)/);
      if (!m) return;
      l.setAttribute('data-vw-ig', '');
      const a = document.createElement('a');
      a.className = 'vw-ig-handle'; a.href = 'https://www.instagram.com/' + m[1] + '/';
      a.target = '_blank'; a.rel = 'noopener'; a.setAttribute('aria-label', '@' + m[1] + ' on Instagram');
      a.innerHTML = icon + '<span></span>'; a.lastChild.textContent = '@' + m[1];
      ['click', 'pointerdown', 'mousedown', 'touchstart'].forEach(ev => a.addEventListener(ev, e => e.stopPropagation()));
      l.replaceChildren(a);
    });
    // heading "Only on @handle" → link to the profile with the Instagram icon
    const fixTitle = () => $$('.instafeed-widget-title:not([data-vw-ig])', box).forEach(h => {
      const txt = h.textContent.trim();
      const m = txt.match(/@([A-Za-z0-9._]+)/);
      const url = m ? 'https://www.instagram.com/' + m[1].replace(/\.$/, '') + '/' : (window.vwInstagram || '');
      if (!url) return;
      h.setAttribute('data-vw-ig', '');
      const a = document.createElement('a');
      a.className = 'vw-ig-title'; a.href = url; a.target = '_blank'; a.rel = 'noopener';
      a.innerHTML = icon.replace('width="12" height="12"', 'width="22" height="22"') + '<span></span>';
      a.lastChild.textContent = txt;
      h.replaceChildren(a);
    });
    const run = () => { fix(); fixTitle(); };
    new MutationObserver(run).observe(box, { childList: true, subtree: true });
    run();
  }

  /* ---------- boot ---------------------------------------- */
  function boot() {
    enhanceInstafeed();
    $$('[data-toc]').forEach(initTOC);
    foldNavColumns();
    $$('[data-announce]').forEach(initAnnounce);
    const hdr = $('#hdr');
    if (hdr) {
      const onScroll = () => hdr.classList.toggle('is-stuck', window.scrollY > 8);
      addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    $$('[data-hero-slider]').forEach(initHero);
    $$('[data-railnav]').forEach(initRail);
    $$('[data-pdp]').forEach(initPDP);
    $$('[data-recent]').forEach(initRecent);
    $$('[data-recs]').forEach(initRecs);
    initPickers(document);
    initSearch();
    reveal(document);
    syncWish();

    addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

    document.addEventListener('click', e => {
      const t = e.target;
      const op = t.closest('[data-open]');
      if (op) { if (open(op.dataset.open)) e.preventDefault(); return; }
      if (t.closest('[data-close]')) { e.preventDefault(); return close(); }
      if (openEl && openEl.classList.contains('vlightbox') && !t.closest('.vlightbox__img, .vlightbox__close')) return close();
      const qv = t.closest('[data-qv]');
      if (qv) { e.preventDefault(); return openQV(qv.dataset.qv, qv); }
      const a = t.closest('[data-add]');
      if (a) { e.preventDefault(); if (a.getAttribute('aria-disabled') === 'true') return; return addToCart([{ id: Number(a.dataset.add), quantity: 1 }], a); }
      const w = t.closest('[data-wish]');
      if (w) { e.preventDefault(); return toggleWish(w.dataset.wish); }
      const q = t.closest('[data-qty]');
      if (q && !q.disabled) { e.preventDefault(); return changeLine(q.dataset.qty, Number(q.dataset.q), q); }
      const cx = t.closest('.cx__t'); if (cx) { cx.parentElement.classList.toggle('is-open'); return; }
      const nv = t.closest('.nvd__t');
      if (nv && nv.tagName === 'BUTTON') { const g = nv.parentElement; g.classList.toggle('is-open'); nv.setAttribute('aria-expanded', g.classList.contains('is-open')); return; }
      const acc = t.closest('.acc__t'); if (acc) { acc.parentElement.classList.toggle('is-open'); return; }
      const fg = t.closest('.fgroup__t'); if (fg) { fg.parentElement.classList.toggle('is-open'); return; }
      const cp = t.closest('[data-copy-link]');
      if (cp) {
        const done = () => { toast('Link copied'); };
        if (navigator.clipboard) navigator.clipboard.writeText(cp.dataset.copyLink).then(done, () => {});
        return;
      }
      const nvLink = t.closest('#nvd a[href*="#"]');
      if (nvLink) close();
    });

    document.addEventListener('input', e => {
      const attr = e.target.closest('[data-cart-attr]');
      if (attr) return saveCartField({ attributes: { [attr.dataset.cartAttr]: attr.value } });
      if (e.target.closest('[data-cart-note]')) return saveCartField({ note: e.target.value });
    });
    document.addEventListener('submit', e => {
      const f = e.target.closest('[data-discount-form]');
      if (f) { e.preventDefault(); applyDiscount(f); }
    });

    const deep = location.hash.replace('#', '');
    if (['cart', 'wish', 'vsearch', 'nvd'].includes(deep)) open(deep);
  }

  window.VW = { open, close, toast, openQV, addToCart, syncWish, reveal, initPickers };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();
